import { z } from 'my-zod'
import { attachmentModel } from '../attachment/attachment-model'
import { actionPlanTaskGroupModel, actionPlanTaskModel } from './action-plan-tasks-model'
import { ActionPlanTriggers } from './action-plan-triggers-model'
import { actionPlanModel } from './action-plans-model'

export const actionPlanTaskSystemView = actionPlanTaskModel.augment({
  overdue: z.boolean(),
  outfitterId: actionPlanModel.shape.outfitterId.nullable(),
  actionPlanShortId: actionPlanModel.shape.shortId.nullable(),
  actionPlanTriggerId: ActionPlanTriggers.TriggerBase.shape.id.nullable(),
  attachments: attachmentModel.array()
})
export type actionPlanTaskSystemView = z.infer<typeof actionPlanTaskSystemView>

export const actionPlanTaskGroupSystemView = actionPlanTaskGroupModel
export type actionPlanTaskGroupSystemView = z.infer<typeof actionPlanTaskGroupSystemView>
